import React, { useEffect, useState } from "react";
import { Globals as OldGlobals } from "../../global/Globals";
import "./AuditTrail.css";
import { useLanguage } from "../../context/Languagecontext";

const AuditTrailComment = (props) => {
  const [isopen, setIsopen] = useState(false);
  const { Globals ,languages, setLanguages } = useLanguage();

    useEffect(() => {
      setIsopen(props.isOpen);
    }, [props.isOpen]);          

    const handleClick =()=>{
      setIsopen(false);
      props.onClose();
    }

  return (
        <>
        {isopen &&(
            <div className="popup">
              <div className="Audittrail-comment-bg-cover">
                <div className="Audittrail-comment-bg-content">
                <div className="session-popup-title">
                  <h4 className="viewCommentheader">{Globals.AUDITTRAIL.VIEWCOMMENTSACTION} {props.selectedTab === "Proposal Audit Trail" ? props?.itemValue?.actionName?.statusName : props?.itemValue?.actionName}</h4>
                  <img className={`sessionpopup-close-button`} src={Globals.IMG.CLOSE} onClick={()=>{handleClick()}} />
                </div>
                <div className="viewComments-content">
                  <div className="viewComments viewComments-proposal">{props.selectedTab === "Proposal Audit Trail" ? Globals.AUDITTRAIL.VIEWCOMMENTSPROPOSAL : Globals.AUDITTRAIL.VIEWCOMMENTSBRIEF } {'#'}{props.selectedTab === "Proposal Audit Trail" ? props?.itemValue?.propRefNo:props.itemValue?.bRefNo}</div>
                  <div className="viewComments viewComments-actionby">{Globals.AUDITTRAIL.VIEWCOMMENTSACTIONBY} {props.itemValue?.actionBy}</div>
                  {(props?.itemValue?.actionName?.statusName === "Re-assign Requested" || props?.itemValue?.actionName ==="Re-assign Requested") &&(
                    <div className="viewcomments ReassignCluster&ReassignChannel">
                      <div className="viewComments viewComments-cluster">{Globals.AUDITTRAIL.VIEWCOMMENTRECLUSTER} {props.itemValue?.reAssignedCluster}</div>
                      <div className="viewComments viewComments-channel">{Globals.AUDITTRAIL.VIEWCOMMENTRECHANNEL}  {props.itemValue?.reAssignedChannel}</div>
                      </div>
                  )}
                  <div className="viewComments viewComments-comments">{Globals.AUDITTRAIL.VIEWCOMMENTSCOMMENT}   {props.itemValue?.comment}</div>
                </div>
                <div className="session-popup-fotter">
                  <button className={`session-popup-action`} onClick={()=>{handleClick()}}>{Globals.AUDITTRAIL.CLOSEVIEWCOMMENTS}</button>
                </div>
                </div>
              </div>
            </div>
        )}
        </>
      );
  
};

export default AuditTrailComment;
